import { render, staticRenderFns } from "./TemplateBarbeiros.vue?vue&type=template&id=d21a2d8c&"
import script from "./TemplateBarbeiros.vue?vue&type=script&lang=js&"
export * from "./TemplateBarbeiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports